module.exports = __webpack_public_path__ + "img/32.424ed0fe.png";